import RoomListResourceModel from '../../generated/types/model/resource/RoomListResourceModel';
import ISchedulerListEntry from '../interfaces/ISchedulerListEntry';
import BaseSchedulerListEntryMixin from '../mixin/BaseSchedulerListEntryMixin';

export default class RoomListResourceViewModel extends BaseSchedulerListEntryMixin(RoomListResourceModel) implements ISchedulerListEntry {
  protected transformToDTO() {}
  protected transformFromDTO() {}
}
